var Constants = require('../constants/Constants');
var Invocation = require('../api/Invocation');
var BaseStore = require('./BaseStore');

/**
 * Stores key for each service against their id
 */
var _idLookup = {};
var _upgrading = {};
var _upgradeMessage = {};

var ClientServiceStore = new BaseStore({
    defaultData: []
});

ClientServiceStore.getService = function (serviceId) {
    return this._data[_idLookup[serviceId]];
};

ClientServiceStore.upgrading = function (serviceId) {
    return _upgrading.hasOwnProperty(serviceId);
};

ClientServiceStore.getUpgradeMessage = function (serviceId) {
    return _upgradeMessage[serviceId];
};

ClientServiceStore.register(Constants.api.GET_SERVICES, function (payload) {
    var action = payload.action;

    if (action.state === Constants.request.PENDING) {
        this._loading = true;

        return true;
    }

    if (action.state === Constants.request.FINISHED) {
        this._loading = false;

        var services = action.response.body.services;
        services.sort(function (a, b) {
            var siteSort = a.site.name.localeCompare(b.site.name);
            if (!siteSort) {
                var type = a.service.type.localeCompare(b.service.type);
                if (!type) {
                    return a.service.name.localeCompare(b.service.name);
                }
                return type;
            }
            return siteSort;
        });

        this.setData(services);
        this._data.forEach(function (service, i) {
            _idLookup[service.id] = i;
        });

        return true;
    }
});

ClientServiceStore.register(Constants.client_service.UPGRADE, function (payload) {
    var service = payload.action.service;
    var plan = payload.action.plan;

    _upgrading[service.id] = true;

    var handlePlanUpgrade = function (res) {
        delete _upgrading[service.id];

        _upgradeMessage[service.id] = {
            type: "success",
            plan: plan,
            invoice: res.body.invoice
        };

        this._data[_idLookup[service.id]] = res.body.client_service;
    }.bind(this);

    var handlePlanFailure = function (err) {
        if (!err.res || !err.res.body || !err.res.body.violations) {
            throw err;
        }

        var messages = err.res.body.violations.map(function (message) {
            return message.property_path + " - " + message.message;
        });

        _upgradeMessage[service.id] = {
            type: "danger",
            errors: messages
        };
    };

    Invocation.clientService.upgrade(service.id, plan.id)
        .then(handlePlanUpgrade)
        .catch(handlePlanFailure)
        .then(() => this.promiseChange())
        .done();

    return true;
});

module.exports = ClientServiceStore;



// WEBPACK FOOTER //
// ./app/stores/ClientServiceStore.js